import React from 'react'
import TextField from '@mui/material/TextField'
import { Formik, FieldArray } from 'formik'
import * as Yup from 'yup'
import MediaQuery from 'react-responsive'
import Button from '@mui/material/Button'
import { ConversionDialog } from '../../molecules/conversionDialog'
import { RadioInput } from '../../atoms/radioInput'
import IncomeAndExpensesImage from '../../images/incomeandexpenses.svg'
import * as S from './styles'
import { buildPayload } from '../../services/RDstation'

const ThirdPartyExpensesSchema = Yup.object().shape({
	dependentCount: Yup.number().required('Selecione uma opção'),
	dependents: Yup.array()
		.when('dependentCount', (dependentCount) => 
			Yup.array().min(dependentCount, 'Favor preencher todos os campos').max(dependentCount, 'Favor preencher todos os campos')
		)
})

const isButtonDisabled = (values) => {
	return false;
}

export function ThirdPartyExpenses({ data, setData, setStepState, stepState, hasConverted, setHasConverted }) {
	const [open, setOpen] = React.useState(false)

	const handleClickOpenDialog = () => {
		if(hasConverted){
			setStepState({
				index: 2,
				enable: 2
			})
		} else {
			if(window.mixpanel){
				window.mixpanel.track("INSS Dialog")
			}
			setOpen(true)
		}
	}

	const handleCloseDialog = (back) => {
		setOpen(false)
		if(!back){
			setStepState({
				index: 2,
				enable: 2
			})
		}
	}

	return (<Formik
	validateOnBlur={false}
	validateOnChange={false}
	initialValues={data}
	validationSchema={ThirdPartyExpensesSchema}
	onSubmit={(values) => {
		if(window.mixpanel){
			window.mixpanel.track("Initial simulation", buildPayload(data, {name:"Vazio", email:"Vazio"}, "mixpanel").track)
		}
		setData({ ...data, ...values })

		handleClickOpenDialog();
	}}
	>
		{({ values, errors, handleChange, handleSubmit, dirty }) => (<>
			<S.Container>
				<S.Form>
					<RadioInput 
						id="dependentCount"
						name="dependentCount"
						label="Quantos dependentes você declara?"
						setData={setData} 
						value={values.dependentCount}
						handleChange={handleChange}
						onChange={(e) => {
							let dependents = data.dependents;
							dependents.splice(Number(e.target.value), 10)
							setData({
								...data,
								dependentCount: e.target.value,
								dependents
							})
						}}
						error={errors.dependentCount}
						data={data} 
						options={
							Array(8)
								.fill()
								.map((_, i) => ({
									id: String(i),
									value: String(i)
								}))
						}
					/>
					{values.dependentCount && (

						<FieldArray
							name="dependents"
							render={arrayHelpers => (
								<>
									{
										Array(Number(values.dependentCount))
											.fill()
											.map((it, i) => {
												const dependentNumber = i+1;
												const id = `dependent-${dependentNumber}`
												return (
													<TextField
														fullWidth
														key={id}
														variant="filled"
														id={`dependent-${dependentNumber}`} name={id} type="number"
														onChange={(e) => {
															let dependents = data.dependents;

															dependents[i] = e.target.value
															setData({
																...data,
																dependents
															})
														}}
														label={`Quanto gasta com educação do dependente ${i+1} por ano?`} value={values[id]}
														error={!!errors[id]} helperText={errors[id] || ' '}/>
												)
											})
									}
								</>
							)}
						>
						</FieldArray>
					)}
					{errors['dependents'] && <div className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">{errors['dependents']}</div>}
				</S.Form>
				<ConversionDialog open={open} initialStep={1} handleCloseDialog={handleCloseDialog} data={data} setHasConverted={setHasConverted}/>
				<MediaQuery query="(min-width: 1024px)">
					<S.BoxImage>
						<S.Image src={IncomeAndExpensesImage} alt="Plano de independência financeira" title="Plano de independência financeira"/>
					</S.BoxImage>
				</MediaQuery>
			</S.Container>
			<S.Footer>
				<S.Hr/>
				<Button onClick={() => {
					if(window.mixpanel){
						window.mixpanel.track("Back to step 1 button")
					}
					setStepState({
						...stepState,
						index: 0
					})
				}} className="btn-plan button-back" variant="contained" color="secondary">PASSO ANTERIOR</Button>
				<Button onClick={handleSubmit} disabled={isButtonDisabled(values)} className="btn-plan" variant="contained" color="primary">PRÓXIMO PASSO</Button>
			</S.Footer>
		</>)}
	</Formik>)
}
